<template>
  <v-container fluid fill-height :id="notGatehouse() ? 'loginEmployeeBody' : 'loginBody'">
    <img src="../assets/login/logo.png" style="position: absolute; bottom: 0px; right: 0px; opacity: 0.3" />
    <v-row align="center" justify="center">
      <v-card id="loginBox" width="60%" elevation="10">
        <h1 class="ml-2">{{ versionDetail.license.name }}</h1>
        <h2 class="ml-2">{{ $store.state.auth.wPlaceSettings.name }}</h2>
        <v-form class="ma-4 login" @submit.prevent="login">
          <v-text-field v-model="user" :prepend-inner-icon="mdiAccount" autocomplete type="text" placeholder=" " required></v-text-field>
          <v-text-field v-model="password" :prepend-inner-icon="mdiLock" type="password" placeholder=" " required></v-text-field>
          <v-btn type="submit" block dark color="brown accent-4"
            ><v-icon>{{ mdiLogin }}</v-icon></v-btn
          >
        </v-form>
        <h4 class="text-sm-right mr-2">
          <span v-if="licenseAboutToExpire && !licenseExpired" class="mr-12 red--text"> License expires at: {{ licenseExpiresAt }}! </span>
          <span v-if="licenseExpired" class="mr-12 red--text"> License expired! </span>
          <v-btn v-if="$store.state.allowPasswordReset" text @click="dialogResetPassword = true">reset password</v-btn>
          {{ $store.state.appname }}:
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">{{ $store.state.version }}</span>
            </template>
            <span>
              Version: {{ versionDetail.version }} <br />
              Architecture: {{ versionDetail.arch }} <br />
              OS: {{ versionDetail.os }} <br />
              Compiler: {{ versionDetail.compiler }} <br />
            </span>
          </v-tooltip>
        </h4>
      </v-card>
    </v-row>
    <v-dialog v-model="dialogInitialSettings" persistent max-width="800">
      <DialogInitialSettings v-on:confirmed="settingsConfirmed" />
    </v-dialog>
    <v-dialog v-model="dialogResetPassword" persistent max-width="600">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>
          {{ $tc('label.resetPassword') }}
          <v-spacer />
          <v-icon large @click="dialogResetPassword = false">{{ mdiClose }}</v-icon>
        </v-card-title>
        <v-card-text class="pa-3">
          <v-text-field :label="$t('label.name')" v-model="resetUser" maxlength="128" hide-details />
          <p>{{ $t('msg.passwordResetSend') }}</p>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn color="colorSave" @click="resetPassword" block>{{ $t('label.resetPassword') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogChangePassword" persistent max-width="600">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>
          {{ $tc('label.resetPassword') }}
          <v-spacer />
          <v-icon large @click="dialogChangePassword = false">{{ mdiClose }}</v-icon>
        </v-card-title>
        <v-card-text class="pa-3">
          <v-text-field :label="$t('label.name')" v-model="changePassword.name" maxlength="128" hide-details />
          <v-text-field :label="$t('label.password')" v-model="changePassword.password" type="password" maxlength="128" hide-details />
          <v-text-field
            :label="$t('label.passwordConfirm')"
            v-model="changePassword.passwordConfirm"
            type="password"
            maxlength="128"
            hide-details
          />
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn color="colorSave" @click="setNewPassword" block>{{ $t('label.resetPassword') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import axios from 'axios';
import DialogInitialSettings from '@/components/DialogInitialSettings.vue';

import { mdiLogin, mdiAccount, mdiLock, mdiClose } from '@mdi/js';

export default Vue.extend({
  name: 'LoginView',
  components: { DialogInitialSettings },
  data: () => ({
    versionDetail: {
      license: { name: '' },
      version: '',
      arch: '',
      os: '',
      compiler: '',
      expiresAt: 0,
    },
    licenseExpiresAt: '',
    licenseAboutToExpire: false, // Notifikace 14 dni pred expiraciou
    licenseExpired: false, // Expirovana licence
    user: '',
    password: '',
    dialogInitialSettings: false,
    dialogResetPassword: false,
    dialogChangePassword: false,
    resetUser: '',
    changePassword: {
      key: '',
      name: '',
      password: '',
      passwordConfirm: '',
    },
    mdiLogin: mdiLogin,
    mdiAccount: mdiAccount,
    mdiLock: mdiLock,
    mdiClose: mdiClose,
  }),
  mounted() {
    this.$store.dispatch('logout').finally(() => {
      if (this.$route.query.key) {
        this.changePassword.key = this.$route.query.key.toString();
        this.dialogChangePassword = true;
        let query = Object.assign({}, this.$route.query);
        delete query.key;
        this.$router.replace({ query });
      }
      this.checkVersion();
    });
  },
  methods: {
    login() {
      const action = 'login';
      const user = this.user;
      const password = this.password;
      const clientID = localStorage.getItem('clientID');
      this.$store
        .dispatch('login', {
          action,
          user,
          password,
          clientID,
        })
        .then(() => {
          this.checkTerms()
            .then((result) => {
              if (result) {
                this.$i18n.locale = this.$store.state.auth.language;
                this.$vuetify.lang.current = this.$store.state.auth.language;
                this.$moment.locale(this.$store.state.auth.language);
                if (this.$store.state.auth.employee) {
                  this.$router.push('/employee');
                  return;
                }
                if (this.notGatehouse()) {
                  if (this.$store.state.auth.userSettings.accArchive.read) {
                    this.$router.push('/archive');
                  } else {
                    this.$router.push('/settings');
                  }
                } else {
                  this.$store.dispatch('webSocketOpen');
                  this.$router.push('/workplace');
                }
              } else {
                this.dialogInitialSettings = true;
              }
            })
            .catch(() => {
              this.$store.dispatch('logout');
            });
        })
        .catch(() => {});
    },
    notGatehouse() {
      if (localStorage.getItem('clientID') === null || localStorage.getItem('clientID') === '') {
        return true;
      }
      return false;
    },
    checkVersion() {
      // Ak je lokalne nacashovana stara verzia tak sa zavola full page reload
      axios
        .get('/api/version')
        .then((response) => {
          this.versionDetail = response.data;
          if (response.data.version != this.$store.state.version) {
            alert('Nová verze: ' + response.data.version + ' Potvrďte OK, případně obnovte stránku stiskem CTRL+R');
            document.location.href = '/clear';
          }
          this.versionDetail.expiresAt * 1000 < Date.now() ? (this.licenseExpired = true) : (this.licenseExpired = false); // Expirovana licence
          this.versionDetail.expiresAt * 1000 - 60 * 60 * 24 * 14 * 1000 < Date.now() // Upozornenie 14 dni pred expiraciou
            ? (this.licenseAboutToExpire = true)
            : (this.licenseAboutToExpire = false);
          this.licenseExpiresAt = this.$moment(this.versionDetail.expiresAt * 1000).format(this.$store.state.auth.df.date);
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    checkTerms() {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/termsstate')
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            this.$store.dispatch('catchErrHandler', err);
            reject('error');
          });
      });
    },
    settingsConfirmed() {
      this.dialogInitialSettings = false;
      this.login();
    },
    resetPassword() {
      if (this.resetUser === '') {
        this.$store.commit('globalMessage', 'Please enter your login name');
        return;
      }
      axios
        .post('/api/resetpassword', { name: this.resetUser })
        .then((response) => {
          console.log('RESP: ', response.data);
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
      this.dialogResetPassword = false;
      this.resetUser = '';
    },
    setNewPassword() {
      if (this.changePassword.password !== this.changePassword.passwordConfirm) {
        this.$store.commit('globalMessage', 'Password and password confirm are not the same');
        return;
      }
      if (this.changePassword.password.length < 4) {
        this.$store.commit('globalMessage', 'Password must be at least 4 characters long');
        return;
      }
      axios
        .put('/api/resetpassword', this.changePassword)
        .then((response) => {
          if (response.data.message == 'nameNotFound') {
            this.$store.commit('globalMessage', 'User not found');
            return;
          }
          this.dialogChangePassword = false;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
          this.dialogChangePassword = false;
        });
    },
  },
});
</script>

<style>
#loginBody {
  background-image: url('../assets/login/background.jpg');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}

#loginEmployeeBody {
  background-image: url('../assets/login/backgroundEmployee.jpg');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}

#loginBox {
  background-color: rgba(255, 255, 255, 0.95);
}
</style>
